<template>
  <el-form size="small" ref="formData" :model="formData" label-width="120px" :rules="rules">
    <el-form-item align="left" label="Subject">
      <el-input v-model="formData.et_subject"></el-input>
    </el-form-item>
    <el-form-item align="left" label="Message">
<!--      <el-input v-model="formData.et_msg"></el-input>-->
      <quillEditor ref="myEditor" v-model="formData.et_msg" :options="editorOption" @blur="onEditorBlur($event)">>
      </quillEditor>
    </el-form-item>
    <el-form-item align="left" label="Remark">
      <el-input v-model="formData.et_desc"></el-input>
    </el-form-item>
    <el-form-item align="left" label="Status">
      <el-select v-model="formData.et_status">
        <el-option label="Activation" :value="1"></el-option>
        <el-option label="Disable" :value="0"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item align="right">
      <el-button @click="$emit('closeDialog')">back</el-button>
      <el-button class="el-button--primary" @click="submit('formData')">save</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
  // 引入富文本编辑器
  import {quillEditor, Quill} from 'vue-quill-editor'
  // require styles 富文本编辑器对应的样式
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  import formatParam from './formatParam'

  Quill.register(formatParam)

  const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],
    ['blockquote', 'code-block'],
    [{'header': 1}, {'header': 2}],
    [{'list': 'ordered'}, {'list': 'bullet'}],
    [{'script': 'sub'}, {'script': 'super'}],
    [{'indent': '-1'}, {'indent': '+1'}],
    [{'direction': 'rtl'}],
    [{'size': ['small', false, 'large', 'huge']}],
    [{'header': [1, 2, 3, 4, 5, 6, false]}],
    [{'color': []}, {'background': []}],
    [{'font': []}],
    [{'align': []}],
    ['link', 'image', 'video'],
    ['formatParam','linkParam']     //新添加的工具
  ]
  export default {
    name: 'EmailTemplateUpdate',
    components: {quillEditor},
    props: {
      chooseItem: Object,
      closeDialog: Function,
      dialogSucc: Function
    },
    mounted () {
      this.initButton()
    },
    computed: {
      editor () {
        return this.$refs.myEditor.quill
      },
    },
    data () {
      return {
        editorOption: {
          placeholder: '',
          theme: 'snow',
          modules: {
            toolbar: {
              container: toolbarOptions,
              handlers: {
                shadeBox: null,
                formatParam: () => {     //添加工具方法
                  this.editor.format('formatParam','code') // 格式化
                },
                linkParam: ()=> {
                  this.editor.format('formatParam','link')
                }
              }
            }
          }
        },

        formData: {
          et_msg: '',
          et_desc: '',
          et_status: '',
          et_subject: '',
          et_id: '',
        },
        rules: {}
      }
    },

    created () {
      this.getData()
    },
    methods: {
      initButton: function () {      //在使用的页面中初始化按钮样式
        const sourceEditorButton = document.querySelector('.ql-formatParam')
        sourceEditorButton.innerHTML = '<svg t="1603626224811" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2429"><path d="M576 524.8l374.272 303.104c1.024-4.608 1.536-9.216 1.536-14.336V205.312c0-2.048 0-4.096-0.512-6.144l-375.808 315.392V430.592l337.92-283.648c-8.192-3.584-16.896-5.632-26.112-5.632H136.192c-9.216 0-18.432 2.048-26.112 5.632l338.432 273.92v82.432L72.192 199.168c0 2.048-0.512 4.096-0.512 6.144v608.256c0 11.776 3.072 23.04 9.216 32.768l367.104-308.224v83.456l-304.64 256h744.96c6.656 0 12.8-1.024 18.432-2.56l-330.752-267.776v-82.432z m-512-455.168h896c35.328 0 64 28.672 64 64V885.76c0 35.328-28.672 64-64 64h-896C28.672 949.76 0 921.088 0 885.76V133.632c0-35.328 28.672-64 64-64z" p-id="2430"></path><path d="M480.256 341.504c0-17.92 14.336-31.744 31.744-31.744s31.744 14.336 31.744 31.744v205.824c0 17.92-14.336 31.744-31.744 31.744s-31.744-14.336-31.744-31.744V341.504z m0 304.128c0-17.92 14.336-31.744 31.744-31.744s31.744 14.336 31.744 31.744v25.6c0 17.92-14.336 31.744-31.744 31.744s-31.744-14.336-31.744-31.744v-25.6z" p-id="2431"></path></svg>'
        const sourceEditorButton1=document.querySelector('.ql-linkParam')
        sourceEditorButton1.innerHTML ='<svg t="1603691596330" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1405"><path d="M976 963.2H83.2V70.4h892.8v892.8zM124.8 921.6h812.8V112H124.8v809.6z" fill="" p-id="1406"></path><path d="M405.12 623.968l217.344-217.12 29.408 29.44-217.344 217.088z" fill="" p-id="1407"></path><path d="M518.4 598.4l51.2 48-160 160-156.8-160 156.8-156.8 48 48 28.8-28.8-76.8-76.8-214.4 214.4 214.4 217.6 214.4-217.6-76.8-76.8zM601.6 515.2l51.2 51.2 156.8-160-156.8-156.8-160 156.8 48 48-28.8 28.8-76.8-76.8L652.8 192l214.4 214.4-214.4 214.4-80-76.8z" fill="" p-id="1408"></path></svg>'
      },
      getData () {
        this.formData = JSON.parse(JSON.stringify(this.chooseItem))
      },
      submit (formName) {
        this.$refs[formName].validate(
          (valid) => {
            if (valid) {
              let loading = this.$util.loading()
              this.$api.rootV1.post('/web/emailtemplate/update', this.formData,
                (res) => {
                  this.$alert('update successfully!', 'info', {
                    confirmButtonText: 'confirm',
                    type: 'success',
                    callback: action => {
                      loading.close()
                      this.$emit('dialogSucc')
                    }
                  })
                }, (res) => {
                  this.$alert(`update failed!${res.errmsg}`, 'info', {
                    confirmButtonText: 'confirm',
                    type: 'error',
                    callback: action => {
                      loading.close()
                      this.$emit('closeDialog')
                    }
                  })
                })
            } else {
              this.$message.warning('Please check the input data!')
            }
          }
        )
      }
    }
  }
</script>

<style>
  .ql-container {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    font-family: Helvetica, Arial, sans-serif;
    font-size: 13px;
    height: 200px !important;
    overflow-y: auto !important;
    margin: 0px;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/components/main/emailTemplate/EmailTemplateUpdate.vue